import css from 'styled-jsx/css';

export default css`
  .moduloFAQ {
    margin-top: 50px !important;
    margin-bottom: 80px;
    .faqs {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      .faq-item__header {
        .span {
          display: block;
          font-size: 20px;
        }
        .faq-item__chevron-icon .SvgIconLoader {
          color: getScssValue('gp', 'blue');
        }
      }
      .faq-item__content--opened {
        span {
          font-size: 16px;
          color: #50535a;
        }
      }
      span {
        text-align: inherit;
      }
      .CustomLink.CustomLinkR1:focus {
        outline: none;
      }
      ul {
        max-width: 808px;
      }
    }
    @media screen and (max-width: 768px) {
      .faqs__title {
        font-size: 32px;
      }
      .faq-item__header {
        .span {
          font-size: 18px;
        }
      }
    }
  }
`;
